/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Something_Went_WrongInputs */

const nl_common_something_went_wrong = /** @type {(inputs: Common_Something_Went_WrongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Er ging iets onverwachts mis. Probeer het later opnieuw. Voor snelle hulp maak je een ticket aan via 'Vragen en suggesties', anders kun je mailen naar info@beweegbaas.nl.`)
};

/**

* @param {Common_Something_Went_WrongInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const common_something_went_wrong = /** @type {((inputs?: Common_Something_Went_WrongInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Something_Went_WrongInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_common_something_went_wrong(inputs)
});
export { common_something_went_wrong as "common.something_went_wrong" }